import {
  Dispatch,
  SetStateAction,
  createContext,
  useMemo,
  useState,
  ReactNode,
} from "react";

export interface DialogContextInterface {
  logoutDialog: DialogDefault;
  setLogoutDialog: Dispatch<SetStateAction<DialogDefault>>;
}

interface DialogDefault {
  isOpen: boolean;
  title: string;
  content: ReactNode;
}

export const EmptyDialog: DialogDefault = {
  isOpen: false,
  title: "",
  content: "",
};

const defaultState = {
  logoutDialog: EmptyDialog,
  setLogoutDialog: (dialog: DialogDefault) => {},
};

export const LogoutDialogContext = createContext(defaultState);

type DialogProviderProps = {
  children: ReactNode;
};

export default function LogoutDialogProvider({
  children,
}: DialogProviderProps) {
  const [logoutDialog, setLogoutDialog] = useState<DialogDefault>(EmptyDialog);
  const value = useMemo(
    () => ({ logoutDialog, setLogoutDialog }),
    [logoutDialog]
  );
  return (
    <LogoutDialogContext.Provider value={value}>
      {children}
    </LogoutDialogContext.Provider>
  );
}
